import { Button } from "@mui/material";
import React from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

const Footer = ({
    textbox,
    type,
    isLoading,
    isEdit,
    fieldList,
    handleClose,
    handleClick,
}) => {
    const language = useSelector(
        (state: any) => state.languagesState.languages,
    );

    return (
        <Modal.Footer className="d-flex justify-between items-center">
            <Button
                color="error"
                variant="outlined"
                className="btn-black-outlined"
                onClick={handleClose}
            >
                {language?.buttons?.close ?? "Close"}
            </Button>
            <div className="position-relative overflow-hidden z-1">
                {isLoading && (
                    <div className="circle-loader">
                        <ClipLoader color={"#000"} size={17} />
                    </div>
                )}
                <Button
                    onClick={handleClick}
                    className="tracker-save-btn modal-save-btn"
                    color="primary"
                    variant="contained"
                    disabled={
                        type === "Raw-Json" && textbox
                            ? false
                            : fieldList.length > 0 &&
                              fieldList.some((item) => item.field === "")
                    }
                >
                    {isEdit
                        ? (language?.creat_web_servis?.save ?? "Save")
                        : (language?.creat_web_servis?.create ?? "Create")}
                </Button>
            </div>
        </Modal.Footer>
    );
};

export default Footer;
